import React from "react";
import { Button, type ButtonProps, Icon } from "semantic-ui-react";

interface IProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => void
  loading?: boolean
  fluid?: boolean
  disabled?: boolean
}

export default class NextStepButton extends React.PureComponent<React.PropsWithChildren<IProps>> {
  public render(): JSX.Element {
    const { onClick, loading, fluid, disabled } = this.props;
    const content = this.props.children || RESX.Buttons.btnNextStep;

    return (<Button
      icon
      fluid={fluid}
      loading={loading}
      disabled={disabled}
      labelPosition="right"
      primary
      onClick={onClick}>
      {!loading && <Icon name="arrow right" />}
      {content}
    </Button >);
  }
}
